import { useEffect } from 'react';

export function useCartTriggerListener(onOpen) {
    useEffect(() => {
        const handleTriggerClick = (e) => {
            const trigger = e.target.closest('[data-elite-selections-open-cart]');
            if (!trigger) return;

            e.preventDefault();
            onOpen();
        };

        document.addEventListener('click', handleTriggerClick);
        return () => document.removeEventListener('click', handleTriggerClick);
    }, [onOpen]);
}
